import RegionBlock from './RegionBlock';

const RegionColumn = ({ title, sections }) => {
  return (
    <div className="sector-col">
      <div className="sector-title">{title}</div>
      <div>
        {sections.map((section, index) => (
          <RegionBlock key={index} {...section} />
        ))}
      </div>
    </div>
  );
};

export default RegionColumn;
